import { computed, observable } from "mobx";
import type { IBankAccount } from "./types";
import type { EntityValidationRules } from "../services/validationService";
import { BankAccountFormatType } from "./bankAccountFormatType";
//import BankCodeType from "./bankCodeType";

export default class BankAccount implements IBankAccount {
  @observable accountNumber: string;
  @observable bank: string;

  set bankCode(bank) {
    this.bank = bank;
  }

  @computed
  get bankCode() {
    return this.bank;
  }

  set bankAccountNumber(accountNumber) {
    this.accountNumber = accountNumber;
  }

  @computed
  get bankAccountNumber() {
    return this.accountNumber;
  }

  @observable _formatType: BankAccountFormatType = BankAccountFormatType.CZECH;
}

export const BankAccountValidationRules: EntityValidationRules<BankAccount> = {
  accountNumber: {
    required: "fillAccountNumber",
    isBankAccountNumber: {
      bankCode: false,
      prefix: true,
      validate: (entity: BankAccount) =>
        entity._formatType === BankAccountFormatType.CZECH && entity.accountNumber !== undefined && entity.accountNumber !== "",
    },
    isIBAN: {
      validate: (entity: BankAccount) =>
        entity._formatType === BankAccountFormatType.IBAN && entity.accountNumber !== undefined && entity.accountNumber !== "",
    },
    isAlphanumericText: {
      validate: (entity: BankAccount) => entity._formatType === BankAccountFormatType.OTHER,
    },
    isLength: {
      max: 34,
    },
  },

  bank: {
    requiredIf: {
      condition: (entity: BankAccount) => entity._formatType === BankAccountFormatType.OTHER,
      message: "fillBankCode",
      isAlphanumericText: true,
    },
  },
};
